import React from 'react';
import moment from 'moment';
import useSearchParams from '~/commons/hooks/useSearchParams';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { env } from '~/commons/config';
import { getLang } from '~/commons/helpers';
import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/core/users/departments';

const ListDepartments = ({ roles: rlist }) => {
  const [searchParams, setSearchParams] = useSearchParams(null);

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { email: 1 },
        filter: searchParams.get('roles') ? { department: searchParams.get('roles') } : {},
        actions: {
          fileImport: true,
        },
        cols: [
          {
            key: 'name.full.en',
            sortable: true,
            children: 'Full name',
            getter: (v, r) => getLang(r.name?.full),
          },
          { key: 'userId', sortable: true },
          {
            key: 'department.name',
            children: 'User Roles',
            sortable: true,
          },
          { key: 'email', sortable: true },
          {
            key: 'active',
            sortable: true,
            getter(v) {
              return <FA icon={v ? faEye : faEyeSlash} />;
            },
          },
          {
            key: 'lastLogin',
            sortable: true,
            getter: (v) => (v ? moment(v).format(env.f.dt) : ''),
          },
        ],
        ctrls: [
          <select
            name="roles"
            className="custom-select"
            key={0}
            value={(searchParams.get('roles') ? searchParams.get('roles') : '')}
            onChange={(e) => {
              setSearchParams({ roles: e.target.value });
            }}
          >
            <option value="">All</option>
            {(rlist || []).map((a) => (
              <option key={a.id} value={a.id}>
                {a.name}
              </option>
            ))}
          </select>,
        ],
      }}
    >
      {({ selected, refresh }) => (
        <ListCtrlActivates api={api} selected={selected} onSuccess={refresh} />
      )}
    </ListResource>
  );
};

export default ListDepartments;
